import { Link } from "react-router-dom";

function Pill({ to, label, isActive, activePill, inactiveBase }) {
  if (isActive) {
    return (
      <span className={`px-3 py-1.5 chapter-num tracking-[0.24em] rounded-full border ${activePill}`}>
        {label}
      </span>
    );
  }
  return (
    <Link to={to} className={`px-3 py-1.5 chapter-num tracking-[0.24em] rounded-full border transition-colors ${inactiveBase}`}>
      {label}
    </Link>
  );
}

// Shared 3-way demo switch pill for KLiving demos.
export default function DemoSwitch({ active = "v1", scrolled = true, testid = "demo-switch" }) {
  const isDarkContext = active === "v2";
  const overLightNoScroll = active === "v1" && !scrolled;

  const inactiveBase = isDarkContext
    ? "text-charcoal_ink/70 border-charcoal_ink/25 hover:text-glow_lime hover:border-glow_lime"
    : overLightNoScroll
      ? "text-editorial border-editorial/40 hover:text-lime_kl hover:border-lime_kl"
      : "text-obsidian border-obsidian/25 hover:text-emerald_kl hover:border-emerald_kl";

  const activePill = isDarkContext
    ? "text-charcoal bg-glow_lime border-glow_lime glow-box"
    : "text-editorial bg-obsidian border-obsidian";

  const sep = isDarkContext
    ? "text-charcoal_ink/40"
    : overLightNoScroll ? "text-editorial/50" : "text-obsidian/40";

  return (
    <div className="inline-flex items-center gap-2" data-testid={testid}>
      <Pill to="/" label="DEMO 01" isActive={active === "v1"} activePill={activePill} inactiveBase={inactiveBase} />
      <span className={`chapter-num ${sep}`}>/</span>
      <Pill to="/v2" label="DEMO 02" isActive={active === "v2"} activePill={activePill} inactiveBase={inactiveBase} />
      <span className={`chapter-num ${sep}`}>/</span>
      <Pill to="/v3" label="DEMO 03" isActive={active === "v3"} activePill={activePill} inactiveBase={inactiveBase} />
    </div>
  );
}
